import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sut-liste',
  templateUrl: './sut-liste.component.html',
  styleUrls: ['./sut-liste.component.css']
})
export class SutListeComponent implements OnInit {

  constructor(private dialog:NgbModal ) { }

sutliste=[{id:1,name:'CALPOL ORAL SÜSPANSİYON 120 mg/5ml 150ml şişe',kod:'assets/models/model.ibuprofen.overlay.json',durum:'Aktif'},
           
           {id:2,name:'ADALAT CRONO KONTROLLÜ SALIM TABLETİ 30 mg 20 tablet',kod:'assets/models/model.kalsiyum.overlay.json',durum:'Pasif'}];


  ngOnInit() {
  }


  openSutDecision(){
  
  }
}
